<template>
  <AntProvider>
    <AppPlatform>
      <NuxtPage />
    </AppPlatform>
    <ClientOnly>
      <XModal />
    </ClientOnly>
  </AntProvider>
</template>

<script lang="ts" setup>
import { XModal } from '@/features/modal';
import { openVConsole } from '@rendora/common/utils/vconsole-open';
import { onErrorCaptured } from 'vue';
import { useAntCss } from '~/hooks/useAntCss';
import { isFeishuClient } from '~/utils/feishu';
import AppPlatform from './app-platform.vue';
import AntProvider from './features/provider/instance.vue';
import { useSeo } from './hooks/useSeo';

const runtimeConfig = useRuntimeConfig();
const currentTheme = useTheme();

const isPrivate = runtimeConfig.public.privatization;

if (!isPrivate) {
  useSeo();
  onMounted(() => {
    import('~/utils/benchmark/index').then(({ PerformanceDetector }) => {
      new PerformanceDetector();
    });
    if (isFeishuClient()) {
      openVConsole();
    }
  });
}

useAntCss(currentTheme);

useHead({
  htmlAttrs: {
    class: () => {
      return currentTheme.value;
    },
  },
});

onErrorCaptured((error, instance, info) => {
  // 详细的错误捕获和日志记录
  console.error('🚨 [APP] 组件错误捕获:', {
    message: error.message,
    stack: error.stack,
    name: error.name,
    componentName: instance?.$options?.name || instance?.$options?.__name,
    errorInfo: info,
    url: window?.location?.href,
    userAgent: navigator?.userAgent,
    timestamp: new Date().toISOString(),
  });

  // 如果是开发环境，显示更详细的错误信息
  if (process.env.NODE_ENV === 'development') {
    console.group('🔍 [DEBUG] 错误调试信息');
    console.error('错误对象:', error);
    console.error('组件实例:', instance);
    console.error('错误信息:', info);
    console.groupEnd();
  }

  // 使用错误报告服务（如果可用）
  if (process.client && process.client) {
    // 这里可以调用错误报告服务
    // 例如：errorReportingService.report(error, { componentName: instance?.$options?.name, info })
  }

  // 关键：返回false阻止错误继续传播，防止跳转到404页面
  return false;
});
</script>
